import { Station, StationType } from "modules/common/components/Alarms/types/AlarmsForm";
import { useState, useEffect } from "react";
import { useMetosStationsQueries } from "services/iot/metosStationsHooks";
import { usePinovaStationsQueries } from "services/iot/pinovaStationsHooks";
import { useCountiesQueries } from "services/iot/recordsHooks";
import { useLocation } from "react-router-dom";

export const useAlarmFormQueries = () => {
    const location = useLocation();
    const shouldFetchPinova = !location.pathname.includes(
        "zastita-bilja/brojnost-populacije-stetnika"
    );

    const { isLoading: isMetosStationsLoading, metosStations } = useMetosStationsQueries();
    const { isLoading: isPinovaStationsLoading, pinovaStations } =
        usePinovaStationsQueries(shouldFetchPinova);
    const { isLoading: isCountiesLoading, counties } = useCountiesQueries();

    const [stations, setStations] = useState<Station[]>([]);

    const setInitialStations = () => {
        const pinova = pinovaStations.map(s => ({
            ...s,
            type: StationType.Pinova,
        }));

        const metos = metosStations.map(s => ({
            ...s,
            type: StationType.Metos,
        }));

        setStations([...pinova, ...metos]);
    };

    useEffect(() => {
        if (isMetosStationsLoading || isPinovaStationsLoading || isCountiesLoading) {
            return;
        }

        setInitialStations();
    }, [isMetosStationsLoading, isPinovaStationsLoading, isCountiesLoading]);

    return {
        stations,
        counties,
        isLoading: isMetosStationsLoading || isPinovaStationsLoading || isCountiesLoading,
    };
};
